import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'reactstrap';
import InputText from '../../../../components/FormFields/InputText';
import * as yup from 'yup';
import SelectList from '../../../../components/select/SelectList';
import Textarea from '../../../../components/FormFields/Textarea';
import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import {
  editFinding,
  getAllInvolvedUsers,
  getAllResponsibleUsersData, getRemarkAttachedFile,
} from '../../../../services/findings';
import {useParams} from 'react-router-dom';
import {FINDING_STATUS, PROGRESS_PERCENTAGE, PROGRESS_STATUS, RISK_LEVEL} from '../../const';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import './FindingsForm.scss';
import {format} from 'date-fns';
import roles from "../../../../utils/roles";
import {Tooltip} from "antd";
import Trash from "../../../IncurredRisk/img/Trash.svg";
import DownloadOutlined from "@ant-design/icons/lib/icons/DownloadOutlined";
import http from "../../../../services/httpService";
import {BASE_RESOURCE_URL} from "../../../../utils/const";

const EditFindingsForm = ({editIsDisabled, setEditIsDisabled, data}) => {

  const lang = getLanguage();
  const params = useParams();
  const [usersInvolvedOptions, setUsersInvolvedOptions] = useState([]);
  const [userResponsibleIdOptions, setUserResponsibleIdOptions] = useState([]);
  const [disableUsersInvolved, setDisableUsersInvolved] = useState(true);
  const [departmentIDs,setDepartmentIDs] = useState([]);
  const [schema, setSchema] = useState(
    yup.object().shape({
      departments: yup.array().required(t('message.fieldRequired')).nullable(),
      responsiblePerson: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
      usersInvolved: yup.array().nullable(),
      initialDeadline: yup.date().required(t('message.fieldRequired')).nullable(),
      adjustedDeadline: yup.date().nullable(),
      findingName: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(150, `${t('message.max', {max: 150})}`),
      finding: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      proposedActions: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      managementResponse: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      hdRequestId: yup
          .string()
          .trim(),
      riskLevel: yup.object().required(t('message.fieldRequired')).nullable(),
      findingStatus: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
    }),
  );

  useEffect(() => {
    if (data) {
      methods.reset({
        findingName: data?.data?.name,
        departments: data?.data?.departments?.map(r => ({
          value: r?.id,
          label: lang === 'mne'
            ? r?.name
            : r?.nameEn,
          sectorDirectorId: r?.sectorDirectorId,
        })),
        responsiblePerson: {
          value: data?.data?.responsiblePerson?.id,
          label: data?.data?.responsiblePerson?.fullName,
          authorities: data?.data?.responsiblePerson?.authorities,
        },
        usersInvolved: data?.data?.usersInvolved?.map(r => ({
          value: r?.id,
          label: r?.fullName,
        })),
        revision: {
          id: params?.revisionId,
        },
        findingStatus: {
          value: data?.data?.findingStatus,
          label:
            data?.data?.findingStatus === FINDING_STATUS.INCOMPLETE.value
              ? t('findingStatus.incomplete')
              : data?.data?.findingStatus === FINDING_STATUS.COMPLETED.value
                ? t('findingStatus.completed')
                : data?.data?.findingStatus ===
                FINDING_STATUS.PARTIALLY_COMPLETED.value
                  ? t('findingStatus.partiallyComplete')
                  : data?.data?.findingStatus ===
                FINDING_STATUS.IN_PROGRESS.value
                  ? t('findingStatus.inProgress')
                  : data?.data?.findingStatus === FINDING_STATUS.CONTINUOUS.value
                    ? t('findingStatus.continuous')
                    : t('findingStatus.aborted'),
        },
        responsiblePersonFindingStatus: {
          value: data?.data?.responsiblePersonFindingStatus,
          label:
              data?.data?.responsiblePersonFindingStatus === FINDING_STATUS.NOT_STARTED.value
                  ? t('findingStatus.incomplete')
                  : data?.data?.responsiblePersonFindingStatus === FINDING_STATUS.COMPLETED.value
                      ? t('findingStatus.completed')
                      : data?.data?.responsiblePersonFindingStatus ===
                          FINDING_STATUS.IN_PROGRESS.value
                              && t('findingStatus.inProgress')

        },
        riskLevel: {
          value: data?.data?.riskLevel,
          label:
            data?.data?.riskLevel === RISK_LEVEL.LOW.value
              ? t('riskLevel.low')
              : data?.data?.riskLevel === RISK_LEVEL.MEDIUM.value
                ? t('riskLevel.medium')
                : data?.data?.riskLevel === RISK_LEVEL.NOT_DEFINED.value
                  ? t('riskLevel.notDefined')
                  : data?.data?.riskLevel === RISK_LEVEL.MODERATE.value
                    ? t('riskLevel.moderate')
                    : t('riskLevel.high'),
        },
        progressStatus: {
          value: data?.data?.progressStatus,
          label:
            <span
              style={
                data?.data?.progressStatus === PROGRESS_STATUS.SATISFACTORY.value
                  ? {color: '#37C35C', fontWeight: 'bold'}
                  : data?.data?.progressStatus === PROGRESS_STATUS.MODERATE.value
                    ? {color: '#F59A1F', fontWeight: 'bold'}
                    : {color: '#F5501F', fontWeight: 'bold'}
              }>{data?.data?.progressStatus === PROGRESS_STATUS.SATISFACTORY.value
              ? t('progressStatus.satisfactory')
             : data?.data?.progressStatus === PROGRESS_STATUS.MODERATE.value
                ? t('progressStatus.moderate')
                : t('progressStatus.critical')
            }</span>},
        progressPercentage: {
          value: data?.data?.progressPercentage,
          label:
            data?.data?.progressPercentage === PROGRESS_PERCENTAGE.ZERO.value
              ? '0%'
              : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.TEN.value
                ? '10%'
                : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.TWENTY.value
                  ? '20%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.THIRTY.value
                    ? '30%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.FORTY.value
                    ? '40%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.FIFTY.value
                    ? '50%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.SIXTY.value
                    ? '60%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.SEVENTY.value
                    ? '70%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.EIGHTY.value
                    ? '80%'
                  : data?.data?.progressPercentage === PROGRESS_PERCENTAGE.NINETY.value
                    ? '90%'
                    :'100%',
        },
        proposedActions: data?.data?.proposedActions,
        managementResponse: data?.data?.managementResponse,
        initialDeadline: new Date(data?.data?.initialDeadline),
        adjustedDeadline: data?.data?.adjustedDeadline ? new Date(data?.data?.adjustedDeadline) : null,
        finding: data?.data?.content,
      });
    }
  }, [data]);

  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {handleSubmit, errors, watch, setValue} = methods;
  const submitForm = async (data) => {
    const formatIssueAtDate =
      format(new Date(data.initialDeadline), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.initialDeadline), 'hh:mm:ss');

    const formatIssueAtCurrentDate = data?.adjustedDeadline ? (
      format(new Date(data?.adjustedDeadline), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data?.adjustedDeadline), 'hh:mm:ss')) : null;

    const payload = {
      name: data?.findingName,
      departments: data?.departments?.map(r => ({id: r?.value})),
      responsiblePerson: {
        id: data?.responsiblePerson?.value,
      },
      usersInvolved: data?.usersInvolved?.map(r => ({id: r?.value})),
      revision: {
        id: params?.revisionId,
      },
      riskLevel: data?.riskLevel?.value,
      findingStatus: data?.findingStatus?.value,
      progressStatus: data?.progressStatus?.value,
      progressPercentage: data?.progressPercentage?.value,
      proposedActions: data?.proposedActions,
      managementResponse: data?.managementResponse,
      initialDeadline: formatIssueAtDate,
      adjustedDeadline: formatIssueAtCurrentDate,
      content: data?.finding,
      hdRequestId: data?.hdRequestId,
      id: params?.findingId,
    };
    try {
      const response = await editFinding(params?.findingId, payload);

      if (response.status === 200) {
        Toast.fire({
          title: t('mitigationRisk.message.updateSuccess', {
            entity: t('revisions.finding'),
          }),
          icon: 'success',
        });
        setEditIsDisabled(true);
      }
    } catch (err) {
      if (err.response.data.code === 'finding-exist') {
        Swal.fire({
          text: t('message.findingExists'),
          icon: 'error',
        });
      } else if (
        err.response.data.code === 'missing-responsible-users-in-department'
      ) {
        Swal.fire({
          text: t('revisions.noResponsibleUser'),
          icon: 'error',
        });
      } else if (err.response.data.code === 'finding-invalid-deadline-date') {
        Swal.fire({
          text: t('revisions.findingInvalidDeadlineDate'),
          icon: 'error',
        });
      } else if (err.response.data.code === 'finding-invalid-adjusted-deadline-date') {
        Swal.fire({
          text: t('revisions.findingInvalidAdjustedDeadline'),
          icon: 'error',
        });
      } else if (err.response.data.code === 'finding-adjusted-deadline-removal-not-allowed') {
        Swal.fire({
          text: t('revisions.findingAdjustedDeadlineRemovalNotAllowed'),
          icon: 'error',
        });
      } else {
        Swal.fire({
          text: t('common.deleteFailed3', {
            entity: t('common.revision'),
          }),
          icon: 'error',
        });
      }
    }
  };
  const watchUserResponsible = watch('responsiblePerson');
  const watchUsersInvolved = watch('usersInvolved');
  const watchDepartment = watch('departments');

  const fetchAllUsersInvolved = async () => {
    let selectedDepartmentIds=watchDepartment?.map((d) => {
      return d.value
    })
    try {
      const {data} = await getAllInvolvedUsers(watchUserResponsible['value'], selectedDepartmentIds);
      return data;
    } catch (e) {
    }
  };
  const fetchAllUsersResponsibleData = async (departmentIds) => {
    setDepartmentIDs(departmentIds)
    try {
      const {data} = await getAllResponsibleUsersData(departmentIds);
      return data;
    } catch (e) {
    }
  };

  useEffect(() => {
    if (watchUserResponsible?.value && watchDepartment) {
      setDisableUsersInvolved(false)
      fetchAllUsersInvolved().then((r) => {
        let usersInvolvedOptions = [];
        r.forEach((item) => {
          usersInvolvedOptions.push(
              {value: item.id, label: item?.fullName}
          );
        });
        setUsersInvolvedOptions(usersInvolvedOptions);
      });
    }
  }, [watchUserResponsible, watchDepartment,watchUsersInvolved]);

  useEffect(() => {
    let selectedDepartmentIds=watchDepartment?.map((d) => {
      return d.value
    })
    fetchAllUsersResponsibleData(selectedDepartmentIds).then((r) => {
      let userResponsibleIdOptions = [];
      r.map((item) => {
          userResponsibleIdOptions.push(
              {value: item.id, label: item?.fullName,authorities:item.authorities}
          );
      });
      setUserResponsibleIdOptions(userResponsibleIdOptions);
    });
  }, [watchUsersInvolved,watchDepartment,watchUserResponsible]);

  useEffect(()=>{
    let selectedDepartmentSectorDirectors=watchDepartment?.map((d) => {
      return d.sectorDirectorId
    })

    if(selectedDepartmentSectorDirectors && !selectedDepartmentSectorDirectors?.includes(watchUserResponsible?.value)){
      if (watchUserResponsible && watchUserResponsible.authorities?.includes(roles.role_sector_director)){
        setValue('responsiblePerson', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
      }
    }
    if (watchDepartment === null) {
      setDisableUsersInvolved(true)
      setValue('usersInvolved', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('responsiblePerson', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  },[watchDepartment])

  useEffect(()=>{
    if (watchUserResponsible && watchUsersInvolved){
      let newUsersInvolved=watchUsersInvolved.filter((item) => item?.value!==watchUserResponsible?.value)
      setValue('usersInvolved', newUsersInvolved, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  },[watchUserResponsible])

   function getRemarkFile(file){
    console.log(file)
    return http.get(
        `${BASE_RESOURCE_URL}/api/remark-attachment/${file.id}/download`,
        {
          responseType: "blob",
        }
    )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.fileName);
          document.body.appendChild(link);
          link.click();
        });
  }

  return (
    <FormProvider {...methods}>
      <form
        id={'myForm'}
        onSubmit={handleSubmit(submitForm)}
        className={'editFindingForm'}>
        <Row className='mb-2'>
          <Col className='col-6 col-xl-3'>
            <label className='label-referentId'>
              {t('revisions.findingName')}
            </label>
            <InputText
              type='string'
              name='findingName'
              className='form-control input-field'
              placeholder={t('revisions.placeholder.findingName')}
              id='referenceId'
              disabled={editIsDisabled}
            />
            <label className='label-referentId'>
              {t('revisions.findingContent')}
            </label>
            <Textarea
              type='string'
              name='finding'
              className='form-control input-field'
              placeholder={t('revisions.placeholder.findingContent')}
              id='finding'
              disabled={editIsDisabled}
            />
            <label className='label-referentId'>
              {t('revisions.recommendation')}
            </label>
            <Textarea
              type='string'
              name='proposedActions'
              className='form-control input-field'
              placeholder={t('revisions.placeholder.recommendation')}
              id='finding'
              disabled={editIsDisabled}
            />
            <label className='label-referentId'>
              {t('revisions.managementResponse')}
            </label>
            <Textarea
              type='string'
              name='managementResponse'
              className='form-control input-field'
              placeholder={t('revisions.placeholder.managementResponse')}
              id='managementResponse'
              disabled={editIsDisabled}
            />

          </Col>
          <Col>
            <label className=''>{t('departments.department')}</label>
            <SelectInfinite
              api='/departments'
              isMulti={true}
              name='departments'
              isDepartmentSelect={true}
              labelKey={lang === 'mne' ? 'name' : 'nameEn'}
              className='department'
              placeholder={t('placeholder.departments')}
              isDisabled={editIsDisabled}
            />
            <label className='label-measures'>
              {t('mitigation-measures.IDHDRequest')}
            </label>
            <span className="optional register">
                    {t('common.optional')}
                  </span>
            <InputText
                type='string'
                name='hdRequestId'
                className='form-control input-field'
                placeholder={t('placeholder.IDHDRequest')}
                id='hdRequestId'
                disabled={editIsDisabled}
                defaultValue={data?.data?.hdRequestId}
            />
            <label className=''>
              {t('incurred-risk.placeholder.responsibleUser')}
            </label>
            <SelectInfinite
                api={`users/audit-responsible?paged=true&size=20&sort=firstName&sort.sorted=true&departmentId.in=${departmentIDs}`}
                name="responsiblePerson"
                labelKey="fullName"
                placeholder={t('incurred-risk.placeholder.responsibleUser')}
                className="select"
                queryKeys={'fullName.contains'}
                isDisabled={editIsDisabled}
            />
            <label className=''>{t('revisions.participants')}</label>
            <SelectInfinite
            api={`users/audit-responsible??page=1&size=20&paged=true&sort=firstName&id.notEquals=${watchUserResponsible ? watchUserResponsible['value'] : ''}&departmentId.in=${departmentIDs}`}
            name="usersInvolved"
            labelKey="fullName"
            placeholder={t('revisions.placeholder.participants')}
            className="select"
            isDisabled={editIsDisabled}
            queryKeys={'fullName.contains'}
            isMulti={true}
            />
            <label>{t('revisions.date')}</label>
            <InputDate
              name='initialDeadline'
              className='form-control input-field dateInput'
              disabled={true}
              minDate={new Date()}
            />
            <label>{t('revisions.currentDeadline')}</label>
            <InputDate
              name='adjustedDeadline'
              className='form-control input-field dateInput'
              // minDate={new Date()}
              disabled={editIsDisabled}
            />

          </Col>
          <Col><label className=''>{t('revisions.riskLevel')}</label>
            <SelectList
                name='riskLevel'
                className='select'
                placeholder={t('revisions.placeholder.riskLevel')}
                options={
                  getLanguage() === 'eng'
                      ? [
                        {
                          label: RISK_LEVEL.LOW.en,
                          value: RISK_LEVEL.LOW.value,
                        },
                        {
                          label: RISK_LEVEL.MEDIUM.en,
                          value: RISK_LEVEL.MEDIUM.value,
                        },
                        {
                          label: RISK_LEVEL.MODERATE.en,
                          value: RISK_LEVEL.MODERATE.value,
                        },
                        {
                          label: RISK_LEVEL.HIGH.en,
                          value: RISK_LEVEL.HIGH.value,
                        },
                        {
                          label: RISK_LEVEL.NOT_DEFINED.en,
                          value: RISK_LEVEL.NOT_DEFINED.value,
                        },
                      ]
                      : [
                        {
                          label: RISK_LEVEL.LOW.mne,
                          value: RISK_LEVEL.LOW.value,
                        },
                        {
                          label: RISK_LEVEL.MEDIUM.mne,
                          value: RISK_LEVEL.MEDIUM.value,
                        },
                        {
                          label: RISK_LEVEL.MODERATE.mne,
                          value: RISK_LEVEL.MODERATE.value,
                        },
                        {
                          label: RISK_LEVEL.HIGH.mne,
                          value: RISK_LEVEL.HIGH.value,
                        },
                        {
                          label: RISK_LEVEL.NOT_DEFINED.mne,
                          value: RISK_LEVEL.NOT_DEFINED.value,
                        },
                      ]
                }
                isDisabled={editIsDisabled}
            />
            <label className=''>{t('revisions.referralStatus')}</label>
            <SelectList
                name='findingStatus'
                className='select'
                placeholder={t('revisions.placeholder.findingStatus')}
                options={
                  getLanguage() === 'eng'
                      ? [
                        {
                          label: FINDING_STATUS.COMPLETED.en,
                          value: FINDING_STATUS.COMPLETED.value,
                        },
                        {
                          label: FINDING_STATUS.INCOMPLETE.en,
                          value: FINDING_STATUS.INCOMPLETE.value,
                        },
                        {
                          label: FINDING_STATUS.PARTIALLY_COMPLETED.en,
                          value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                        },
                        {
                          label: FINDING_STATUS.CONTINUOUS.en,
                          value: FINDING_STATUS.CONTINUOUS.value,
                        },
                        {
                          label: FINDING_STATUS.IN_PROGRESS.en,
                          value: FINDING_STATUS.IN_PROGRESS.value,
                        },
                        {
                          label: FINDING_STATUS.ABORTED.en,
                          value: FINDING_STATUS.ABORTED.value,
                        },
                      ]
                      : [
                        {
                          label: FINDING_STATUS.COMPLETED.mne,
                          value: FINDING_STATUS.COMPLETED.value,
                        },
                        {
                          label: FINDING_STATUS.INCOMPLETE.mne,
                          value: FINDING_STATUS.INCOMPLETE.value,
                        },
                        {
                          label: FINDING_STATUS.PARTIALLY_COMPLETED.mne,
                          value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                        },
                        {
                          label: FINDING_STATUS.CONTINUOUS.mne,
                          value: FINDING_STATUS.CONTINUOUS.value,
                        },
                        {
                          label: FINDING_STATUS.IN_PROGRESS.mne,
                          value: FINDING_STATUS.IN_PROGRESS.value,
                        },
                        {
                          label: FINDING_STATUS.ABORTED.mne,
                          value: FINDING_STATUS.ABORTED.value,
                        },
                      ]
                }
                isDisabled={editIsDisabled}
            />
            {data?.data?.responsiblePersonFindingStatus !== null && <> <label className=''>{t('revisions.responsiblePersonFindingStatus')}</label>
              <SelectList
                  name='responsiblePersonFindingStatus'
                  className='select'
                  placeholder={t('revisions.placeholder.findingStatus')}
                  options={
                    getLanguage() === 'eng'
                        ? [
                          {
                            label: FINDING_STATUS.COMPLETED.en,
                            value: FINDING_STATUS.COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.NOT_STARTED.en,
                            value: FINDING_STATUS.NOT_STARTED.value,
                          },
                          {
                            label: FINDING_STATUS.IN_PROGRESS.en,
                            value: FINDING_STATUS.IN_PROGRESS.value,
                          }
                        ]
                        : [
                          {
                            label: FINDING_STATUS.COMPLETED.mne,
                            value: FINDING_STATUS.COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.NOT_STARTED.mne,
                            value: FINDING_STATUS.NOT_STARTED.value,
                          },
                          {
                            label: FINDING_STATUS.IN_PROGRESS.mne,
                            value: FINDING_STATUS.IN_PROGRESS.value,
                          }
                        ]
                  }
                  isDisabled={true}
              />
            </>}
            <label style={{margin: '0', paddingTop: '10px'}} className="label-referentId">
              {t('revisions.progressPercentage')}
            </label>
            <SelectList
                name="progressPercentage"
                className="select-filed"
                placeholder={t('revisions.placeholder.progressPercentage')}
                options={[{
                  label: PROGRESS_PERCENTAGE?.ZERO?.label,
                  value: PROGRESS_PERCENTAGE?.ZERO?.value
                },
                  {
                    label: PROGRESS_PERCENTAGE?.TEN?.label,
                    value: PROGRESS_PERCENTAGE?.TEN?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.TWENTY?.label,
                    value: PROGRESS_PERCENTAGE?.TWENTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.THIRTY?.label,
                    value: PROGRESS_PERCENTAGE?.THIRTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.FORTY?.label,
                    value: PROGRESS_PERCENTAGE?.FORTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.FIFTY?.label,
                    value: PROGRESS_PERCENTAGE?.FIFTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.SIXTY?.label,
                    value: PROGRESS_PERCENTAGE?.SIXTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.SEVENTY?.label,
                    value: PROGRESS_PERCENTAGE?.SEVENTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.EIGHTY?.label,
                    value: PROGRESS_PERCENTAGE?.EIGHTY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.NINETY?.label,
                    value: PROGRESS_PERCENTAGE?.NINETY?.value
                  },
                  {
                    label: PROGRESS_PERCENTAGE?.HUNDRED?.label,
                    value: PROGRESS_PERCENTAGE?.HUNDRED?.value
                  }
                ]}
                isDisabled={true}
            />
            <label style={{margin: '0', paddingTop: '10px'}} className="label-referentId">
              {t('revisions.progressStatus')}
            </label>
            <SelectList
                name="progressStatus"
                className="select-filed"
                placeholder={t('revisions.placeholder.progressStatus')}
                options={[{
                  label: PROGRESS_STATUS?.SATISFACTORY?.label,
                  value: PROGRESS_STATUS?.SATISFACTORY?.value
                },
                  {
                    label: PROGRESS_STATUS?.MODERATE?.label,
                    value: PROGRESS_STATUS?.MODERATE?.value
                  },
                  {
                    label: PROGRESS_STATUS?.CRITICAL?.label,
                    value: PROGRESS_STATUS?.CRITICAL?.value
                  },
                ]}
                isDisabled={true}
            />
            {data?.data?.findingStatus === 'COMPLETED' && <>
              <label className="label-referentId">{t('comments.proofOfRealization')}</label>
              <form
                  style={{height: '108px'}}
                  className="findings-remarks-add-document-comment__field findings-remarks-add-document-comment__edit-field mb-5"
                  onSubmit={(e) => e.preventDefault()}
              >
                <Textarea
                    placeholder={t('comments.noProof')}
                    name="proofComment"
                    id="proofComment"
                    disabled={true}
                    value={data?.data?.completionProof}
                />

                <div
                    style={{position: 'relative', right: '20px', top: '-10px'}}
                >
                  {data?.data?.completionProofFile && (
                      <div
                          className="d-flex align-items-center findings-remarks-file-attachment">
                        <Tooltip title={data?.data?.completionProofFile?.fileName}>
                          <span className="mr-5">{data?.data?.completionProofFile?.fileName}</span>
                        </Tooltip>
                        <DownloadOutlined
                            onClick={() => {
                              try {
                                getRemarkFile(data?.data?.completionProofFile);
                              } catch (e) {
                                console.log(e);
                              }
                            }}
                            style={{fontSize: '16px', color: '#08c', cursor: 'pointer'}}
                        />
                      </div>
                  )}
                </div>
              </form>
            </>}</Col>
        </Row>
      </form>
      {!editIsDisabled ? (
        <div className='container-fluid mt-4 footer'>
          <div className='row'>
            <div className='col-12 pt-4 pb-4 d-flex justify-content-end footer'>
              <button
                className='secondary-btn'
                onClick={(event) => {
                  event.preventDefault();
                  methods.reset({
                    findingName: data?.data?.name,
                    departments: data?.data?.departments?.map(r => ({
                      value: r?.id,
                      label: lang === 'mne'
                        ? r?.name
                        : r?.nameEn,
                    })),
                    responsiblePerson: {
                      value: data?.data?.responsiblePerson?.id,
                      label: data?.data?.responsiblePerson?.fullName,
                    },
                    usersInvolved: data?.data?.usersInvolved?.map(r => ({
                      value: r?.id,
                      label: r?.fullName,
                    })),
                    revision: {
                      id: params?.revisionId,
                    },
                    riskLevel: {
                      value: data?.data?.riskLevel,
                      label: data?.data?.riskLevel,
                    },
                    proposedActions: data?.data?.proposedActions,
                    managementResponse: data?.data?.managementResponse,
                    initialDeadline: data?.data?.initialDeadline ? new Date(
                      data?.data?.initialDeadline?.split('T')[0],
                    ) : null,
                    adjustedDeadline: data?.data?.adjustedDeadline ? new Date(
                      data?.data?.adjustedDeadline?.split('T')[0],
                    ) : null,
                    finding: data?.data?.content,
                  });
                  setEditIsDisabled(true);
                }}>
                {t('common.cancel')}
              </button>
              <button
                type='submit'
                form={'myForm'}
                className='primary-btn revisionEditFormButton'
                disabled={!methods.formState.isDirty}>
                {t('common.save')}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </FormProvider>
  );
};

export default EditFindingsForm;
